import React from 'react';

const ProjectTypeListing = ({ data, onEdit, onDelete, isLoading, searchQuery }) => {
    return (
        <div
            className="table-card"
            style={{
                overflowX: 'auto',
                WebkitOverflowScrolling: 'touch',
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                paddingBottom: '10px'
            }}
        >
            <table className="custom-table" style={{ minWidth: '700px' }}>
                <thead>
                    <tr>
                        <th width="10%" style={{ textAlign: 'center' }}>STT</th>
                        <th width="50%">LOẠI CÔNG TRÌNH</th>
                        <th width="20%" style={{ textAlign: 'center' }}>ĐIỂM</th>
                        <th width="20%" style={{ textAlign: 'center' }}>CHỨC NĂNG</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <tr>
                            <td colSpan="4" style={{ textAlign: 'center', padding: '60px', color: '#003399' }}>
                                <i className="fa-solid fa-circle-notch fa-spin" style={{ fontSize: '35px', marginBottom: '15px', display: 'block' }}></i>
                                Đang tải dữ liệu
                            </td>
                        </tr>
                    ) :
                        !Array.isArray(data) || data.length === 0 ? (
                            <tr>
                                <td colSpan="4" style={{ textAlign: 'center', padding: '50px', color: '#888' }}>
                                    <i className="fa-solid fa-magnifying-glass-minus" style={{ fontSize: '30px', display: 'block', marginBottom: '15px', color: '#ccc' }}></i>
                                    {(!Array.isArray(data)) ? "Lỗi dữ liệu hoặc chưa được cấp quyền" : "Không tìm thấy loại công trình nào phù hợp"}
                                </td>
                            </tr>
                        ) : (
                            data.map((item, index) => (
                                <tr key={item.Id}>
                                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                    <td style={{ fontWeight: '500' }}>{item.Name}</td>
                                    <td style={{ textAlign: 'center', fontWeight: 'bold', color: '#0056b3' }}>{item.Score}</td>
                                    <td>
                                        <div className="action-group">
                                            <div className="icon-wrapper edit-wrapper" title="Sửa" onClick={() => onEdit(item)}>
                                                <i className="fa-solid fa-pen edit-icon"></i>
                                            </div>
                                            <div className="icon-wrapper delete-wrapper" title="Xóa" onClick={() => onDelete(item.Id)}>
                                                <i className="fa-solid fa-trash delete-icon"></i>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                </tbody>
            </table>
        </div>
    );
};

export default ProjectTypeListing;